/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StoreProfileAddress } from './StoreProfileAddress';
import {
    StoreProfileAddressFromJSON,
    StoreProfileAddressFromJSONTyped,
    StoreProfileAddressToJSON,
    StoreProfileAddressToJSONTyped,
} from './StoreProfileAddress';
import type { StoreProfileImageMetaData } from './StoreProfileImageMetaData';
import {
    StoreProfileImageMetaDataFromJSON,
    StoreProfileImageMetaDataFromJSONTyped,
    StoreProfileImageMetaDataToJSON,
    StoreProfileImageMetaDataToJSONTyped,
} from './StoreProfileImageMetaData';
import type { StoreProfileContact } from './StoreProfileContact';
import {
    StoreProfileContactFromJSON,
    StoreProfileContactFromJSONTyped,
    StoreProfileContactToJSON,
    StoreProfileContactToJSONTyped,
} from './StoreProfileContact';

/**
 * 
 * @export
 * @interface StoreOverview
 */
export interface StoreOverview {
    /**
     * 
     * @type {StoreOverviewTypeEnum}
     * @memberof StoreOverview
     */
    type: StoreOverviewTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof StoreOverview
     */
    name: string;
    /**
     * 
     * @type {Date}
     * @memberof StoreOverview
     */
    openingDate?: Date;
    /**
     * 
     * @type {StoreProfileAddress}
     * @memberof StoreOverview
     */
    address?: StoreProfileAddress;
    /**
     * 
     * @type {StoreProfileContact}
     * @memberof StoreOverview
     */
    contact: StoreProfileContact;
    /**
     * 
     * @type {StoreProfileImageMetaData}
     * @memberof StoreOverview
     */
    headerImage?: StoreProfileImageMetaData;
}


/**
 * @export
 */
export const StoreOverviewTypeEnum = {
    Online: 'ONLINE',
    Local: 'LOCAL'
} as const;
export type StoreOverviewTypeEnum = typeof StoreOverviewTypeEnum[keyof typeof StoreOverviewTypeEnum];


/**
 * Check if a given object implements the StoreOverview interface.
 */
export function instanceOfStoreOverview(value: object): value is StoreOverview {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('contact' in value) || value['contact'] === undefined) return false;
    return true;
}

export function StoreOverviewFromJSON(json: any): StoreOverview {
    return StoreOverviewFromJSONTyped(json, false);
}

export function StoreOverviewFromJSONTyped(json: any, ignoreDiscriminator: boolean): StoreOverview {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'name': json['name'],
        'openingDate': json['openingDate'] == null ? undefined : (new Date(json['openingDate'])),
        'address': json['address'] == null ? undefined : StoreProfileAddressFromJSON(json['address']),
        'contact': StoreProfileContactFromJSON(json['contact']),
        'headerImage': json['headerImage'] == null ? undefined : StoreProfileImageMetaDataFromJSON(json['headerImage']),
    };
}

export function StoreOverviewToJSON(json: any): StoreOverview {
    return StoreOverviewToJSONTyped(json, false);
}

export function StoreOverviewToJSONTyped(value?: StoreOverview | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'name': value['name'],
        'openingDate': value['openingDate'] == null ? value['openingDate'] : value['openingDate'].toISOString(),
        'address': StoreProfileAddressToJSON(value['address']),
        'contact': StoreProfileContactToJSON(value['contact']),
        'headerImage': StoreProfileImageMetaDataToJSON(value['headerImage']),
    };
}

